import React from 'react';

import { Header } from '../../components/Header';

export const BaseLayout: React.FC<React.PropsWithChildren> = ({
  children
}) => (
  <main>
    <Header />

    {children}
  </main>
);
